import { Button } from "./ui/button";
import { FileText, Plus } from "lucide-react";

export const EmptyState = ({ onCreateFile }) => {
  return (
    <div 
      className="h-full flex flex-col items-center justify-center p-8"
      data-testid="empty-state"
    >
      <div
        className="absolute inset-0 bg-cover bg-center opacity-5 pointer-events-none"
        style={{
          backgroundImage: `url('https://images.unsplash.com/photo-1761888856976-c4bc8303f65f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwxfHxtaW5pbWFsaXN0JTIwYWJzdHJhY3QlMjBnZW9tZXRyaWMlMjBzaGFwZXMlMjBjYWxtfGVufDB8fHx8MTc3MDM4MDg3MXww&ixlib=rb-4.1.0&q=85')`
        }}
      />
      
      <div className="relative z-10 text-center max-w-md animate-fade-in">
        <div className="w-16 h-16 rounded-2xl bg-primary/10 flex items-center justify-center mx-auto mb-6">
          <FileText className="w-8 h-8 text-primary" />
        </div>
        
        <h2 className="text-2xl font-bold tracking-tight mb-3">
          No note selected
        </h2>
        
        <p className="text-muted-foreground mb-8">
          Select a note from the sidebar to start editing, or create a new one to begin writing.
        </p>
        
        <Button 
          onClick={onCreateFile}
          size="lg"
          className="gap-2"
          data-testid="create-first-note-button"
        >
          <Plus className="w-4 h-4" />
          Create New Note
        </Button>
      </div>
    </div>
  );
};
